var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundedBadge = function SvgRoundedBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.144,
    height: 16.144,
    y: 0.675,
    fill: "#000",
    rx: 8.072
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m4.14 8.747 2.483 2.483 5.175-5.174"
  })));
};
export { SvgRoundedBadge as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC42NzQ1NjEiIHdpZHRoPSIxNi4xNDQyIiBoZWlnaHQ9IjE2LjE0NDIiIHJ4PSI4LjA3MjA4IiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNC4xMzk1MyA4Ljc0NjZMNi42MjMyNCAxMS4yMzAzTDExLjc5NzcgNi4wNTU5MSIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";